// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pRNBc","title":"Header_title__tfrz5","left":"Header_left__1ODep","clinicName":"Header_clinicName__2p63M"};